import { Loading, decryptData, defaulUrl } from "../components/const";
import UseFetch from "../components/UseFetch";
import { Link, NavLink } from "react-router-dom";
import { useRef, useState } from "react";
import Swal from "sweetalert2";
import DetailConteneur from "./DetailConteneur";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import $ from 'jquery';

const Contenaires = () => {
    let { data: conteneurs, isloading } = UseFetch('conteneurs/liste');
    let [detailproduct, setDetailProduct] = useState([]);
    let [date1, setDate1] = useState(null);
    let [date2, setDate2] = useState(null);
    const [trieConteneurs, setTrie] = useState(null);
    const user = decryptData('USER');
    const isAdmin = user.droit === 'Administrateur';
    const tableRef = useRef(null);

    const handleTriByDate = (e) => {
        if (!date1 || !date2) {
            Swal.fire({
                title: "Date(s) invalides!",
                text: "Choisissez de bonnes dates pour date1 et date 2 ",
                icon: "error",
                toast: true,
                position: "center",
                color: 'white',
                iconColor: 'white',
                background: 'red'
            });
            return;
        }
        e.preventDefault();
        setTrie(conteneurs.filter((conteneur) => conteneur.created_at >= date1 && conteneur.created_at <= date2 + 1));
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: "Confirmez votre opération",
            text: 'Souhaitez-vous vraiment supprimer ce conteneur?',
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            confirmButtonColor: "green"
        }).then((rep) => {
            if (rep.isConfirmed) {
                isloading = true;
                fetch(`${defaulUrl}conteneurs/delete/${id}`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
                    }
                }).then((response) => response.json())
                    .then(data => {
                        Swal.fire({
                            title: "Succès",
                            text: data.message,
                            icon: 'success',
                            timer: 5000
                        })
                    })
            }
        })
    };

    // 🔹 Fonction PDF dynamique pour tous les champs
    const printConteneurs = (title, tab = []) => {
        if (!tab || tab.length === 0) {
            alert("Aucune donnée à imprimer !");
            return;
        }

        const doc = new jsPDF("landscape");
        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255);
        doc.text("FANSAN TEXTIL", 105, 20, { align: "center" });
        doc.setFontSize(14);
        doc.text(title?.toUpperCase() || "", 105, 30, { align: "center" });

        // Colonnes selon le tableau HTML
        const headers = ["N°CONT", "CONTENEURS", "FOURNISSEUR", "TELEPHONE", "STATUT", "DATE AJOUT"];
        const data = tab.map(cont => [
            cont.numfact || "",
            cont.conteneur || "",
            cont.Fournisseur || "",
            cont.telephone || "",
            cont.statut ? 'Mis en approvision' : 'Disponible',
            cont.created_at || ""
        ]);

        autoTable(doc, {
            startY: 40,
            head: [headers],
            body: data,
            headStyles: { fillColor: [52, 58, 64], textColor: 255 },
            theme: "grid",
        });

        // Pied de page
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(10);
        doc.text(new Date().toLocaleDateString(), 105, pageHeight - 20, { align: "center" });
        doc.text(user?.droit?.toUpperCase() || "", 105, pageHeight - 10, { align: "center" });

        doc.save(`${title || "conteneurs"}.pdf`);
    };

    conteneurs = conteneurs?.sort((a, b) => a.statut - b.statut);
    $(tableRef.current).DataTable();

    return (
        <div className="Conteneur container-fluid ">
            <div className="row my-2">
                <div className="col-lg-8 h2 text-primary">
                    GESTION DES CONTENEURS
                </div>
                {isAdmin && <div className="col-lg-4 text-end">
                    <NavLink to='/conteneurs/add' type="button" className="btn btn-primary ">Nouveau conteneur</NavLink>
                </div>}
            </div>
            {isloading ? <Loading /> :
                conteneurs?.length ?
                    <div className="row">
                        <div className="row justify-content-between m-0 align-items-center">
                            <div className="col-lg-6">
                                <div className="row align-items-center">
                                    <input type="date" className="form-control w-auto m-1" id="date1" name="date1" defaultValue={date1} onChange={(e) => setDate1(e.target.value)} />
                                    <input type="date" className="form-control w-auto m-1" id="date2" name="date2" defaultValue={date2} onChange={(e) => setDate2(e.target.value)} />
                                    <button onClick={(e) => handleTriByDate(e)} type="submit" className="btn btn-primary w-auto"><i className="bx bx-search"></i></button>
                                    <button className="btn btn-primary w-auto m-1" onClick={() => printConteneurs("Liste des conteneurs", conteneurs)}>
                                        <i className="bx bx-printer"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table ref={tableRef} className="table table-white shadow table-bordered nowrap table-hover table-striped border-primary">
                                <thead className="table-dark border-primary">
                                    <tr className="text-center">
                                        <th>N°CONT</th>
                                        <th>CONTENEURS</th>
                                        <th>FOURNISEUR</th>
                                        <th>TELEPHONE</th>
                                        <th>STATUT</th>
                                        <th>DATE AJOUT</th>
                                        <th className="text-end">ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody className="plage">
                                    {(trieConteneurs || conteneurs).map((cont, ind) => (
                                        <tr key={cont.id} className="tr">
                                            <td>{cont.numfact}</td>
                                            <td>{cont.conteneur}</td>
                                            <td>{cont.Fournisseur}</td>
                                            <td>{cont.telephone}</td>
                                            <td className="conteneur">{cont.statut ? 'Mis en approvision' : 'Disponible'}</td>
                                            <td>{cont.created_at}</td>
                                            <td className="text-end">
                                                <Link title="Détail"
                                                    to={`/approvisions/${cont.idappro}`}
                                                    state={{ 'appro': cont }}
                                                    className="btn btn-sm btn-primary m-1"
                                                >
                                                    <i className="bx bx-show"></i>
                                                </Link>
                                                {(cont.statut === 0) && <button className="btn btn-danger m-1" onClick={() => handleDelete(cont.id)}><i className="bx bx-trash"></i></button>}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    : <div className="row fs-5 py-2 justify-content-center bg-danger-subtle text-danger fs-3">
                        Aucun conteneur enregistré!
                    </div>
            }

            <DetailConteneur conteneur={detailproduct} />
        </div>
    );
}

export default Contenaires;
